<template>
  <div class="error-page">
    <div class="error-cont">
      <strong>이용에 불편을 드려 죄송합니다.</strong>
      <p>요청하신 페이지를 찾을 수 없습니다.</p>
      <a href="/usr/main" class="btn">사이트 메인으로 이동</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  metaInfo() {
    return {
      title: "KHFF | Not Found",
    };
  },
};
</script>
